import {Component} from '@angular/core';
import {Subject} from "rxjs";

@Component({
    selector: 'app-roster-update-modal',
    templateUrl: './roster-update-modal.component.html',
    styleUrls: ['./roster-update-modal.component.scss'],
    standalone: false
})
export class RosterUpdateModalComponent {

    public cancel$: Subject<void>;
    public confirm$: Subject<void>;

    public buttonState: boolean;

    public set parameter(buttonState: boolean) {
        this.buttonState = buttonState;
    }
    constructor() {
        this.cancel$ = new Subject();
        this.confirm$ = new Subject();
    }

    public dismissModal(): void {
        this.cancel$.next();
    }

    public confirmModal(): void {
        this.confirm$.next();
    }
}
